// src/NumberSorter.js

import React, { useState } from 'react';
import './NumberSorter.css';
import StatsCalculator from './StatsCalculator';

const NumberSorter = () => {
  const [numbers, setNumbers] = useState('');
  const [operation, setOperation] = useState('smallest');
  const [result, setResult] = useState(null);

  const handleNumbersChange = (e) => {
    setNumbers(e.target.value);
  };

  const handleOperationChange = (e) => {
    setOperation(e.target.value);
  };

  const calculateResult = () => {
    const numArray = numbers.split(',').map(Number).filter(n => !isNaN(n));

    let res;
    switch (operation) {
      case 'smallest':
        res = Math.min(...numArray);
        break;
      case 'largest':
        res = Math.max(...numArray);
        break;
      case 'ascending':
        res = numArray.sort((a, b) => a - b).join(', ');
        break;
      case 'descending':
        res = numArray.sort((a, b) => b - a).join(', ');
        break;
      default:
        res = null;
    }
    setResult(res);
  };

  return (
    <div className="number-sorter">
      <h1>Find out Smallest number, Largest number, ascending order and descending order</h1>
      <div>
        <label>
          Numbers (comma separated):
          <input type="text" value={numbers} onChange={handleNumbersChange} />
        </label>
      </div>
      <div>
        <label>
          Operation:
          <select value={operation} onChange={handleOperationChange}>
            <option value="smallest">Smallest Number</option>
            <option value="largest">Largest Number</option>
            <option value="ascending">Ascending Order</option>
            <option value="descending">Descending Order</option>
          </select>
        </label>
      </div>
      <button onClick={calculateResult}>Calculate</button>
      {result !== null && <div className="result">Result: {result}</div>}
      <hr/>
      
      <StatsCalculator/>
    </div>
  );
};

export default NumberSorter;
